<template>
  <div class="activeView">
    <div
      class="activeview-top"
      :style="{
        backgroundImage:
          'url(' + ($isCdn(activeinfo.eventPic) || require('@/assets/image/activecheck/active-base1.png')) + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }"
    >
      <div class="active-infobox">
        <div class="active-title  p2-overflow">{{ activeinfo.eventName }}</div>
        <div class="active-info">
          <div class="active-time">{{ activeinfo.startDate }}~{{ activeinfo.endDate }}</div>
          <div class="active-type" :class="`type-${activeinfo.status}`">
            {{ activeinfo.status === 2 ? '进行中' : activeinfo.status === 3 ? '已结束' : '未开始' }}
          </div>
        </div>
      </div>
    </div>
    <div class="active-tabs">
      <van-tabs v-model="active" color="#007AFF" title-active-color="#007AFF">
        <van-tab title="活动签到" name="a">
          <checkActive></checkActive>
        </van-tab>
        <van-tab title="活动介绍" name="b">
          <activeintroduce></activeintroduce>
        </van-tab>
        <van-tab title="签到记录" name="c"></van-tab>
      </van-tabs>
    </div>
    <!-- <checkActive v-if="active == 'a'"></checkActive> -->
    <checkrecord v-if="active == 'c'"></checkrecord>
  </div>
</template>

<script>
import checkActive from './activecheck'
import activeintroduce from './activeintroduce.vue'
import checkrecord from './checkrecord.vue'
import {geteventSignInfo} from '@/api'
export default {
  components: {checkActive, activeintroduce, checkrecord},
  mounted() {
    this.getcheckinfo()
  },
  data() {
    return {
      active: 'a',
      activeinfo: {}
    }
  },
  methods: {
    getcheckinfo() {
      const params = {
        eventSignId: this.$route.query.id,
        forType: 11
      }
      geteventSignInfo(params).then(res => {
        // this.checklist = res.data.eventSignConfigMobileList
        if (res.success) {
          this.activeinfo = res.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.activeView {
  .activeview-top {
    height: 166px;
    width: 100%;
    position: relative; // 添加相对定位，便于内容定位
  }
  .active-infobox {
    z-index: 1;
    position: absolute;
    bottom: 0;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 12px 12px 0px 0px;
    border: 2px solid rgba(255, 255, 255, 0.4);
    height: 103px;
    width: 100%;
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .active-title {
      font-size: 16px;
      font-weight: 500;
      color: #1a1a1a;
    }
    .active-info {
      display: flex;
      align-items: center;
      .active-time {
        font-size: 14px;
        color: #595959;
      }
      .active-type {
        display: flex;
        width: 48px;
        height: 20px;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        color: #fff;
        border-radius: 20px;
        margin-left: 12px;
        &.type-2 {
          background-color: #17be6b;
        }
        &.type-1 {
          background-color: #007aff;
        }
        &.type-0 {
          background-color: #007aff;
        }
        &.type-3 {
          background-color: #86909c;
        }
      }
    }
  }
}
</style>
